module.exports = __webpack_public_path__ + "public/Icons/startIcon.svg?cddfd1a0";